import React from 'react';
import { Button, Link } from 'shared';

import {
  HeaderBlockDescription,
  HeaderBlockImage,
  HeaderBlockTitle,
  HeaderBlockWrapper,
  HeaderBlockWrapperLayer,
} from './HeaderBlock.styles';
import { HeaderBlockProps } from './HeaderBlock.types';

export const HeaderBlock = ({ title, description, image, link, overlayColor }: HeaderBlockProps) => {
  return (
    <HeaderBlockWrapper className="header-block">
      {image && <HeaderBlockImage className="header-block__image" src={image} alt="" />}
      <HeaderBlockWrapperLayer className="header-block__layer" overlayColor={overlayColor}>
        <HeaderBlockTitle className="header-block__title">{title}</HeaderBlockTitle>
        {description && (
          <HeaderBlockDescription className="header-block__description">{description}</HeaderBlockDescription>
        )}
        {link && (
          <Button as={Link} {...link} className="header-block__link">
            {link.label}
          </Button>
        )}
      </HeaderBlockWrapperLayer>
    </HeaderBlockWrapper>
  );
};
